import React, { FC } from "react";

import BaseDataTable from "../../../../../components/modules/BaseDataTable";
import Loader from "../../../../../components/elements/Loader";
import classes from "./CreativeAssets.module.scss";
import { CreativeAsset, CreativeTemplateAsset } from "../../../../../types/adGroupTypes";

type CreativeAssetsProps = {
  creativeAssets: (CreativeTemplateAsset | CreativeAsset)[];
  isFetchingCreatives: boolean;
};

const CreativeAssets: FC<CreativeAssetsProps> = ({ creativeAssets, isFetchingCreatives }) => {
  const columns = [
    { key: "asset", label: "Asset", minWidth: 170 },
    { key: "name", label: "Name", minWidth: 170 },
    { key: "description", label: "Description", minWidth: 170 },
    { key: "height", label: "Height", minWidth: 170 },
    { key: "width", label: "Width", minWidth: 170 },
    { key: "creativeType", label: "Creative Type", minWidth: 170 },
    { key: "createdDate", label: "Creative Date", minWidth: 170 },
  ];

  if (creativeAssets && creativeAssets.length > 0 && creativeAssets[0].creativeType === "video/mp4") {
    const insertIndex = 2;
    const newColumn = { key: "duration", label: "Duration", minWidth: 170 };
    columns.splice(insertIndex, 0, newColumn);
  }

  const rows = creativeAssets
    .sort((a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf())
    .map((asset) => {
      const { name, description, createdAt, creativeType, height, width, duration } = asset;
      let id;
      if ("id" in asset) {
        id = asset.id;
      } else {
        id = asset.adGroupId;
      }

      let creativeSrc;
      if ("creativeTemplateSrc" in asset) {
        creativeSrc = asset.creativeTemplateSrc;
      } else {
        creativeSrc = (asset as CreativeAsset).creativeSrc;
      }
      const imageRegex: RegExp = /^image\//;
      const row = {
        id,
        asset: imageRegex.test(creativeType) ? (
          <img className={classes.creativeAssetImg} src={creativeSrc} alt="Creative Asset" />
        ) : (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video controls style={{ width: "300px" }}>
            <source src={creativeSrc} type="video/mp4" />
          </video>
        ),
        name,
        description,
        height,
        width,
        creativeType,
        createdDate: new Date(createdAt).toLocaleDateString(),
        ...(creativeType === "video/mp4" ? { duration: `${duration ?? "60"} sec` } : {}),
      };
      return row;
    });

  return creativeAssets.length !== 0 ? (
    <BaseDataTable columns={columns} rows={rows} />
  ) : creativeAssets.length === 0 && isFetchingCreatives ? (
    <div className={classes.loaderContainer}>
      <Loader isAbsolutePosition={false} size={36} />
    </div>
  ) : null;
};

export default CreativeAssets;
